import { combineReducers } from "redux";

import companyAnalysisCompetitorsReducer from "app/pages/sales-intelligence/modules/company-analysis/store/competitors/reducer";
import companyAnalysisContactsReducer from "app/pages/sales-intelligence/modules/company-analysis/store/contacts/reducer";

const companyAnalysisReducer = combineReducers({
    contacts: companyAnalysisContactsReducer,
    competitors: companyAnalysisCompetitorsReducer,
});

export default companyAnalysisReducer;
